import type {
  PostDocumentDuplicateRequestType,
  PostDocumentDuplicateResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentsDuplicate = async (
  params: PostDocumentDuplicateRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/duplicates`;
  const response = await apiAuthClient.post<PostDocumentDuplicateResponseType>(
    url,
    params.body,
  );

  return response.data;
};
